import React from 'react';
import {AnalyticsApiResponse} from 'client/Reports/reports.types';
import {history} from 'client/history';
import {isFinalDimension} from 'client/Reports/reports.utils';
import {WithRouterProps, withRouter} from 'react-router';
import classNames from 'classnames';
import {IconButton, WithTooltip} from '@albert-io/atomic';

interface CellProps extends WithRouterProps {
  data?: any;
  dataRenderer: (data: AnalyticsApiResponse) => JSX.Element;
  className?: string;
  defaultSort?: boolean;
}

const Cell = withRouter(({data, dataRenderer, className, defaultSort, location}: CellProps) => {
  const {pathname, search} = location;

  const {id} = data.dimensions[0].value;

  const showDrilldown = defaultSort && !isFinalDimension(pathname.split('/'));

  return (
    <td className={className}>
      <div
        className={classNames({
          'u-display_flex': showDrilldown,
          'u-justify-content_space-between': showDrilldown,
          'u-align-items_center': showDrilldown
        })}
      >
        {dataRenderer(data)}
        {showDrilldown && (
          <WithTooltip content='Drilldown' placement='top'>
            <IconButton
              className='reports-table__column-button reports-table__drilldown-button'
              variant='solid'
              color='primary'
              size='s'
              label='Drilldown'
              onClick={() => {
                if (!isFinalDimension(pathname.split('/'))) {
                  history.pushState(null, `${pathname}/${id}${search}`);
                }
              }}
              icon='arrow-right'
            />
          </WithTooltip>
        )}
      </div>
    </td>
  );
});

export default Cell;
